import { motion, AnimatePresence } from "framer-motion";
import React, { ReactNode } from "react";
import { SDKWrapper } from "./SDKWrapper";

interface ModalProps {
  title: string;
  children: ReactNode;
  onClose: () => void;
  onOutsideClick?: () => void;
  overlayOpacity?: string;
  topDistance?: string;
  open?: boolean;
}

export function Modal({
  title,
  children,
  onClose,
  onOutsideClick,
  overlayOpacity = "bg-black bg-opacity-100",
  topDistance = "pt-[100px]",
  open = true,
}: ModalProps) {
  return (
    <SDKWrapper>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className={`fixed inset-0 z-50 flex items-start justify-center ${topDistance} ${overlayOpacity} px-4 sm:px-0`}
            onClick={onOutsideClick || onClose}
            aria-modal="true"
            role="dialog"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="relative max-h-[90vh] w-full max-w-lg p-0 flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between pb-[14px]">
                <h2 className="text-base sm:text-lg font-semibold text-[#E6E8ED]">
                  {title}
                </h2>
                <button
                  onClick={onClose}
                  aria-label="Close modal"
                  className="text-gray-400 hover:text-white text-xl sm:text-2xl px-2"
                >
                  &times;
                </button>
              </div>
              <div className="border border-[#292930] rounded-[9px] bg-[#0D0D10] shadow-lg flex flex-col max-h-[70vh] overflow-y-auto [&::-webkit-scrollbar]:w-1.5 sm:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-[#292930] [&::-webkit-scrollbar-track]:border-0 [&::-webkit-scrollbar-thumb]:bg-[#808080] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:border-0">
                <div className="px-4 sm:px-6 py-4 sm:py-6 relative">
                  {children}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </SDKWrapper>
  );
}
